import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationChatterTotalChatsByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.chatterId], chatterLabelMap)[0],
        data: item.chats || [],
      })),
    }),
    [data, chatterLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Total Chats Over Time"
      subtitle="Chat volume trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load chat totals over time."
      valueType="number"
    />
  );
};

export default OrganizationChatterTotalChatsByTimeChart;
